import React, { useCallback } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import strings from 'strings';
import AutocompleteSelect from 'UI/components/molecules/AutocompleteSelect';
import { Endpoints } from 'UI/constants/endpoints';
import { idOptionSelected, REQUIRED_VALIDATION } from 'UI/utils';

import { FORM_FIELDS_MAP } from '../../drawers/CreateSendoutDrawer/SendoutForm/SendoutForm.constants';

const getRecruiterLabel = option => option?.fullName || option?.full_name || '';

export const AccountableRecruiterSelector = ({
  jobOrderId = null,
  fieldName = FORM_FIELDS_MAP.AccountableRecruiter.key
}) => {
  const { control, errors } = useFormContext();

  const handleOnChange = useCallback(([, value]) => value, []);

  return (
    <Controller
      name={fieldName}
      control={control}
      rules={REQUIRED_VALIDATION}
      defaultValue={null}
      as={
        <AutocompleteSelect
          name={fieldName}
          error={!!errors[fieldName]}
          errorText={errors[fieldName]?.message}
          placeholder={strings.sendouts.form.labels.accountableRecruiter}
          url={
            jobOrderId
              ? Endpoints.JobOrderAvailableRecruitersForSendout.replace(':id', jobOrderId)
              : null
          }
          apiVersion={2}
          getOptionLabel={getRecruiterLabel}
          getOptionSelected={idOptionSelected}
        />
      }
      onChange={handleOnChange}
      onChangeName="onSelect"
      valueName="selectedValue"
    />
  );
};
